import { Injectable } from '@angular/core';

import { GraphQLService } from '@app/services';
import { 
    mutationSendOrder
} from '@app/graphql-queries';

@Injectable({
  providedIn: 'root'
})
export class ShopOrdersService {
    
    constructor(
        private graphQLService: GraphQLService
    ) { }
    
    async sendOrder(operationID: string, shopProductID: string, quantity: number): Promise<boolean>{
        let status: boolean = false;        
        let response = await this.graphQLService.mutate({   
            mutation: mutationSendOrder,
            variables: {
                operationID: operationID,
                params: JSON.stringify({
                    shopProductID: shopProductID,
                    quantity: quantity
                })
            }       
        });     
        if(response?.data?.SendOrder){
            status = true;
        }
        return status;
    }
    
}
